import { api } from './utils'

export interface IGetMFAQRCode {
	image: string

	success: boolean
	message: string
}

export interface ISetMFA {
	success: boolean
	message: string
}

export async function getMFAQRCore(): Promise<IGetMFAQRCode> {
	return await (await fetch(
		`${api}/cabinet/getMFA`,
		{
			method: 'POST'
		}
	)).json() as IGetMFAQRCode
}

async function changeMFA(code: string, endpoint: string) {
	return fetch(
		`${api}/cabinet/${endpoint}`,
		{
			method: 'POST',
			body: JSON.stringify({
				code: code ? code.replace(new RegExp(' ', 'g'), '') : ''
			})
		}
	)
}

export async function enableMFA(code: string): Promise<ISetMFA> {
	return await (await changeMFA(code, 'setMFA')).json() as ISetMFA
}


export async function disableMFA(code: string): Promise<ISetMFA> {
	return await (await changeMFA(code, 'removeMFA')).json() as ISetMFA
}
